import { Tooltip } from '@material-ui/core';
import ProdutoModel from 'models/Produto';
import { useEffect, useState } from 'react';
import { Col } from 'reactstrap';
import api from 'services/api';
import SelectProdutos from 'utils/SelectProdutos';
import GerenciamentoEmailBase from '../../GerenciamentoEmailBase';
import useGerenciamentoEmail from '../../Hooks/useGerenciamentoEmail';

const GerenciamentoEmailProduto = ({ tipo }: { tipo: string }): JSX.Element => {
  const [produtosSelecao, setProdutosSelecao] = useState<ProdutoModel[]>([]);

  const gerenciamento = useGerenciamentoEmail({
    tipo,
    montarPayload: grupo => ({
      email: grupo.email,
      nome: grupo.nome,
      produtos: grupo.produtoId,
      tipo,
    }),
  });

  async function carregaProdutos(): Promise<void> {
    const response = await api.get('produto');

    setProdutosSelecao(response.data);
  }

  useEffect(() => {
    carregaProdutos();
  }, []);

  return (
    <GerenciamentoEmailBase
      tipo={tipo}
      {...gerenciamento}
      renderCamposEspecificos={(grupoEmail, handleSetCadDetalheValue) => {
        const produtosSelecionados = (grupoEmail.produtoId ?? []).map(
          produtoId => ({
            value: produtoId,
            label: '',
          }),
        );

        return (
          <Col sm="5">
            <Tooltip
              title={
                <span style={{ fontSize: '1rem' }}>
                  Os produtos selecionados neste campo serão os que o usuário
                  irá receber alertas sobre, ignorando todos os outros não
                  marcados. Caso nenhum seja selecionado, o usuário irá receber
                  alertas sobre todos os produtos.
                </span>
              }
              placement="top"
            >
              <div style={{ width: '100%' }}>
                <SelectProdutos
                  produtos={produtosSelecao}
                  onChange={produtos =>
                    handleSetCadDetalheValue(
                      grupoEmail,
                      'produtoId',
                      produtos.map(produto => produto.value),
                    )
                  }
                  value={produtosSelecionados}
                  isMulti
                />
              </div>
            </Tooltip>
          </Col>
        );
      }}
    />
  );
};

export default GerenciamentoEmailProduto;
